import { render, staticRenderFns } from "./diagnosisCouponIssue.vue?vue&type=template&id=05485dfc&scoped=true"
import script from "./diagnosisCouponIssue.vue?vue&type=script&lang=js"
export * from "./diagnosisCouponIssue.vue?vue&type=script&lang=js"
import style0 from "./diagnosisCouponIssue.vue?vue&type=style&index=0&id=05485dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05485dfc",
  null
  
)

export default component.exports